export default "__VITE_ASSET__BrHZgz6W__"